const user = state => state.user
const config = state => state.config

export {
  user,
  config
}



// WEBPACK FOOTER //
// ./src/store/getters.js